<script>
	import EditExpenseRecordModal from "./EditExpenseRecordModal.svelte";

	// Props
	export let collapseId;
	export let listItemId;
	export let date;
	export let month;
	export let total;
	export let recordList;

	// Variables
	let OpenModal = false;
	let RecordId;
	let RecordDate;
	let RecordIndex;

	const sendItemDataToDeleteModal = (index, item) => {
		RecordIndex = index;
		RecordId = item.recordId;
		RecordDate = item.expenseDate;
	};

	const handleEditExpense = (index, recordListItem) => {
		OpenModal = true;
		sendItemDataToDeleteModal(index, recordListItem);
	};
</script>

<div class="row">
	<div class="col">
		<div class="list-group">
			<button
				data-toggle="collapse"
				data-target={`#${listItemId}`}
				type="button"
				class="list-group-item list-group-item-action text-capitalize rounded-0 h5 mb-0 d-flex justify-content-between align-items-center list-group-item-warning">
				{`${date} - ${month}`}
				<span
					class="badge badge-pill badge-warning">{total
						.toString()
						.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}/-</span>
			</button>

			<div class="collapse" id={collapseId}>
				<div class="card card-body rounded-0 pl-5 py-0 pr-0">
					<ul
						class="list-group expense-record-list-group d-flex flex-row flex-wrap justify-content-end">
						{#each recordList as recordListItem, index (recordListItem.recordId)}
							<li
								class="col-12 col-lg m-w-50 border-top-0 list-group-item list-group-item-action text-capitalize rounded-0 h5 mb-0 d-flex justify-content-between align-items-center">
								{recordListItem.expenseTitle}

								<div class="d-flex align-items-center">
									<button
										class="btn p-0 edit-btn mr-2"
										on:click={handleEditExpense(index, recordListItem)}>
										<svg
											width="1.3em"
											height="1.3em"
											viewBox="0 0 16 16"
											class="bi bi-pencil-square"
											fill="currentColor"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
											<path
												fill-rule="evenodd"
												d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
										</svg>
									</button>

									<span
										class="badge badge-pill badge-warning">{recordListItem.expenseAmount
											.toString()
											.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}/-</span>
								</div>
							</li>
						{/each}
					</ul>
				</div>
			</div>
		</div>
	</div>
</div>

<EditExpenseRecordModal
	recordIndex={RecordIndex}
	recordId={RecordId}
	recordDate={RecordDate}
	open={OpenModal}
	on:closeEditModal={() => (OpenModal = false)} />
